var map = {
	"./log": "./node_modules/webpack/hot/log.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/webpack/hot ^\\.\\/log$";


//////////////////
// WEBPACK FOOTER
// (webpack)/hot nonrecursive ^\.\/log$
// module id = ./node_modules/webpack/hot ^\.\/log$
// module chunks = 0